import React, { useEffect, useState } from "react";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

function AccountTab({ formData, handleRefresh }) {
  const AppService = useAppServices();
  const [success, setSuccess] = useState("");
  const [claim_business, setClaim_business] = useState([]);
  const [OpenClaimModel, setOpenClaimModel] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [actionType, setActionType] = useState("");

  const getClaimBusiness = async () => {
    if (!formData?.id) return;

    const { response } = await AppService.claim_business.Get({
      query: `business_id=${formData.id}&status=approved`,
    });

    if (response) {
      setClaim_business(response.data);
    }
  };

  useEffect(() => {
    getClaimBusiness();
  }, [formData]);

  const handleUnclaim = async (id, type) => {
    const payload = {
      _id: id,
      type,
    };

    const { response } = await AppService.claim_business.unClaimListing({ payload });

    if (response) {
      getClaimBusiness();
    }
  };

  const tableTHStyles = {
    fontFamily: "Poppins",
    fontWeight: 600,
  };

  return (
    <div>
      <p className="text-center">{success}</p>
      {/* table where show name, content, and rating */}
      <SoftBox>
        <div className="overflow-x-auto">
          <table className="table w-100" style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#F7F7F7", borderRadius: "18px" }}>
                <th
                  className="p-20-px text-left"
                  style={{
                    ...tableTHStyles,
                    borderBottomLeftRadius: "18px",
                    borderTopLeftRadius: "18px",
                  }}
                >
                  Name
                </th>
                <th
                  className="p-20-px text-left"
                  style={{
                    ...tableTHStyles,
                  }}
                >
                  Email
                </th>
                <th
                  className="p-20-px text-left"
                  style={{
                    ...tableTHStyles,
                    borderBottomRightRadius: "18px",
                    borderTopRightRadius: "18px",
                  }}
                >
                  Un claim
                </th>
              </tr>
            </thead>
            <tbody>
              {claim_business.map((review) => (
                <tr
                  key={review._id}
                  style={{ cursor: "pointer", borderBottom: "1px solid #DDDDDD" }}
                >
                  <td className="p-20-px">{`${review.first_name} ${review.last_name}`}</td>
                  <td className="p-20-px">{review.email}</td>
                  <td className="p-20-px" style={{ display: "flex", gap: "10px" }}>
                    <button
                      onClick={() => {
                        setSelectedId(review._id);
                        setActionType("status");
                        setOpenClaimModel(true);
                      }}
                      style={{
                        padding: "6px 12px",
                        fontSize: "14px",
                        backgroundColor: "black",
                        color: "#ffffff",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      Unclaim
                    </button>
                    {/* <button
                      onClick={() => {
                        setSelectedId(review._id);
                        setActionType("delete");
                        setOpenClaimModel(true);
                      }}
                      style={{
                        padding: "6px 12px",
                        fontSize: "14px",
                        backgroundColor: "#ef4444",
                        color: "#ffffff",
                        borderRadius: "6px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      Delete Claim
                    </button> */}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {OpenClaimModel && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0,0,0,0.5)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                width: "360px",
                backgroundColor: "#ffffff",
                borderRadius: "10px",
                padding: "20px",
                textAlign: "center",
              }}
            >
              <h3 style={{ marginBottom: "10px", fontSize: "18px" }}>Confirm Action</h3>

              <p style={{ fontSize: "14px", marginBottom: "20px", color: "#555" }}>
                {actionType === "delete"
                  ? "Are you sure you want to delete this claim? This action cannot be undone."
                  : "Are you sure you want to unclaim this business?"}
              </p>

              <div style={{ display: "flex", justifyContent: "center", gap: "10px" }}>
                {/* Cancel */}
                <button
                  onClick={() => setOpenClaimModel(false)}
                  style={{
                    padding: "6px 14px",
                    backgroundColor: "#e5e7eb",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>

                {/* Confirm */}
                <button
                  onClick={() => {
                    handleUnclaim(selectedId, actionType);
                    setOpenClaimModel(false);
                  }}
                  style={{
                    padding: "6px 14px",
                    backgroundColor: actionType === "delete" ? "#ef4444" : "black",
                    color: "#ffffff",
                    border: "none",
                    borderRadius: "6px",
                    cursor: "pointer",
                  }}
                >
                  {actionType === "delete" ? "Delete" : "Unclaim"}
                </button>
              </div>
            </div>
          </div>
        )}
      </SoftBox>
    </div>
  );
}

export default AccountTab;
